import React from 'react';
import TableC from '../../../basicElement/TableC';
import format from '../../../shared/format';

export default function CrcPerformance(props) {
    const { loading, data } = props;

    const getColumns = () => ([{
        title: '时间',
        dataIndex: 'date',
        key: 'date',
        width: 80,
        render: (text, record) => format('month', record.recordYear, record.recordMonth),
    }, {
        title: 'CRC姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 100,
    }, {
        title: 'CRC工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 100,
    }, {
        title: '主要业绩分',
        dataIndex: 'crcMainAchievementPoint',
        key: 'crcMainAchievementPoint',
        width: 100,
    }, {
        title: '与访视相关得分',
        dataIndex: 'visitScore',
        key: 'visitScore',
        width: 100,
    }, {
        title: '与访视无关得分',
        dataIndex: 'notVisitScore',
        key: 'notVisitScore',
        width: 100,
    }, {
        title: '带教身份',
        dataIndex: 'isMain',
        key: 'isMain',
        width: 100,
        render: (text) => text != null ? `${text ? '主' : '次'}带教老师` : '',
    }]);

    const getDataSource = () => {
        return data || [];
    };

    return (
        <div>
            <div style={{ lineHeight: '48px' }}>2.被带教人员的CRC绩效-主要业绩分明细</div>
            <TableC
                scrollY={300}
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                className="crcPerformance"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/CrcPerformance.js